import styled from 'styled-components'

const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  overflow: hidden;
  margin-bottom: ${props => (props.smallMargin ? '16px' : '24px')};
`

export { PriceContainer }
